// extracted by mini-css-extract-plugin
export default {"container":"support-banner_container__A+VsN","grid-container":"support-banner_grid-container__ta7f4"};